import { render, staticRenderFns } from "./BtnDeletePackage.vue?vue&type=template&id=68dfc01d"
import script from "./BtnDeletePackage.vue?vue&type=script&lang=js"
export * from "./BtnDeletePackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports